// extracted by mini-css-extract-plugin
module.exports = {"bold":"UpgradeButton_bold__YbHen"};